import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Modal, Row, Col, Typography, Button, Divider } from "antd";
import { Form } from "formik-antd";
import { Formik } from "formik";
import { useParams } from "react-router-dom";

import { useLocale, useStore } from "../../../hooks";
import { FIELDS } from "../../../constants";
import { FormField } from "../../../components/private";
import SeoFieldsGenerator from "./SeoFieldsGenerator";
import { toJS } from "mobx";

const { Text } = Typography;

const SubCategoryModal = ({ title, data }) => {
  const { FieldsStore } = useStore();
  const { id: categoryId } = useParams();
  const {
    modal,
    editableData: { subCategory },
    toggleModal,
    editMode,
  } = FieldsStore;
  const t = useLocale("fields/form");

  const isSubCategory = modal === "subCategory";
  const [formValues, setFormValues] = useState(
    FIELDS.subCategory.defaultFormValues
  );

  const [isInitialValid, setIsInitialValid] = useState(false);
  const schema = FIELDS.subCategory.formValidation;

  useEffect(() => {
    schema
      .validate(formValues)
      .then(() => setIsInitialValid(true))
      .catch(() => setIsInitialValid(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues]);

  useEffect(() => {
    if (isSubCategory)
      setFormValues({
        categoryTitle: subCategory.categoryTitle,
        slug: subCategory.slug,
        hasPrice: subCategory.hasPrice,
        hasRent: subCategory.hasRent,
        hide: subCategory.hide,
        seo: toJS(subCategory.seo),
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubCategory]);

  const onRequestClose = () => {
    toggleModal("subCategory", FIELDS.subCategory.defaultFormValues);
    setFormValues(FIELDS.subCategory.defaultFormValues);
  };

  const handleSubmit = (form) => {
    if (editMode) {
      const item = data.find(
        (item) => item.key === String(subCategory.categoryID)
      );
      item && item.update(form);
    } else {
      FieldsStore.createModel({
        form,
        categoryId,
        type: "category",
      });
    }
    onRequestClose();
  };

  return (
    <Modal
      title={title}
      className="category-modal"
      visible={isSubCategory}
      onCancel={onRequestClose}
      destroyOnClose
      footer={null}
      maskClosable={true}
      width={900}
    >
      <Formik
        initialValues={formValues}
        enableReinitialize
        validationSchema={schema}
        isInitialValid={isInitialValid}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form layout="vertical" size="large">
            <Text>{t("subCategories.formTitle")}</Text>
            <Row
              justify="start"
              align="middle"
              gutter={[48, 0]}
              style={{ marginTop: 25 }}
            >
              <Col span={24}>
                <Row>
                  <Col span={22}>
                    <Row>
                      <Col span={24} md={{ span: 12 }}>
                        <FormField
                          loading={false}
                          name="categoryTitle"
                          placeholder={t(
                            "subCategories.fields.title.placeholder"
                          )}
                        />
                      </Col>
                      <Col span={24} md={{ span: 12 }}>
                        <FormField
                          loading={false}
                          name="slug"
                          placeholder={t(
                            "subCategories.fields.slug.placeholder"
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col span={22}>
                    <Row>
                      <Col span={24} md={{ span: 12 }}>
                        <FormField
                          type="switch"
                          name="hasPrice"
                          placeholder={t(
                            "subCategories.fields.hasPrice.placeholder"
                          )}
                        />
                      </Col>
                      <Col span={24} md={{ span: 12 }}>
                        <FormField
                          type="switch"
                          name="hasRent"
                          placeholder={t(
                            "subCategories.fields.hasRent.placeholder"
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col span={22}>
                    <Row>
                      <Col span={24} md={{ span: 12 }}>
                        <FormField
                          type="switch"
                          name="hide"
                          placeholder={t(
                            "subCategories.fields.hide.placeholder"
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Divider />
                <SeoFieldsGenerator
                  config={FIELDS.subCategory.seoConfig}
                  formik={formik}
                />
              </Col>
            </Row>

            <Button
              htmlType="submit"
              style={{ marginLeft: 14 }}
              onClick={formik.handleSubmit}
              type="primary"
              size="middle"
            >
              {t(`subCategories.buttons.${editMode ? "edit" : "add"}`)}
            </Button>

            <Button
              htmlType="button"
              size="middle"
              style={{ fontSize: 14 }}
              onClick={onRequestClose}
              type="default"
            >
              {t(`subCategories.buttons.cancel`)}
            </Button>
          </Form>
        )}
      </Formik>
      {/* </div> */}
    </Modal>
  );
};
export default observer(SubCategoryModal);
